import { render, staticRenderFns } from "./DoKoDialogWaitingForInvites.vue?vue&type=template&id=716e81ef&scoped=true&"
import script from "./DoKoDialogWaitingForInvites.vue?vue&type=script&lang=ts&"
export * from "./DoKoDialogWaitingForInvites.vue?vue&type=script&lang=ts&"
import style0 from "./DoKoDialogWaitingForInvites.vue?vue&type=style&index=0&id=716e81ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716e81ef",
  null
  
)

export default component.exports